import { useState } from 'react'

import { ProjectsCreateForm } from '@/components/forms/projects/create'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import useTranslator from '@/hooks/translation'

export function ProjectsCreateDialog() {
  const { getTranslation } = useTranslator()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOnOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      setIsModalOpen(true)
    } else {
      setIsModalOpen(false)
    }
  }

  return (
    <Dialog open={isModalOpen} onOpenChange={handleOnOpenChange}>
      <DialogTrigger asChild>
        <Button
          variant="fintalk"
          size="sm"
          onClick={() => setIsModalOpen(true)}
        >
          {getTranslation('common.newProject')}
        </Button>
      </DialogTrigger>

      <DialogContent className="p-0">
        <DialogHeader className="p-6 px-8 pb-2">
          <DialogTitle>{getTranslation('projects.modal.create')}</DialogTitle>
        </DialogHeader>

        <Separator />

        <ProjectsCreateForm
          isModalOpen={isModalOpen}
          setIsModalOpen={handleOnOpenChange}
        />
      </DialogContent>
    </Dialog>
  )
}
